import { Component, OnInit, OnDestroy, Renderer } from '@angular/core';
import { InformacionService } from '../../services/informacion.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { ValidationService } from '../../services/validation.service';
import { ContactosService } from '../../services/contactos.service';
import { Contacto } from '../../interfaces/contactos.interface';
import { Router } from '@angular/router';
import * as moment from 'moment';

@Component({
  selector: 'app-contacto',
  templateUrl: './contacto.component.html'
})
export class ContactoComponent implements OnInit, OnDestroy {
  forma: FormGroup;
  contacto: Contacto = {
    fecha: '',
    nombre: '',
    email: '',
    mensaje: ''
  }
  constructor(  public _is: InformacionService,
                private renderer: Renderer,
                private _cs: ContactosService,
                private router: Router ) {
    this.renderer.setElementClass(document.body, 'paginas-internas', true);
  }

  ngOnInit() {
    this.forma = new FormGroup({
      'fecha': new FormControl(moment().format()),
      'nombre' : new FormControl('', [Validators.required, Validators.minLength(3)]),
      'email' : new FormControl('', [Validators.required, ValidationService.emailValidator]),
      'mensaje' : new FormControl('', [Validators.required, Validators.minLength(10)])
    })
  }
  enviar() {
    console.log(this.forma.value);
    console.log(this.forma);
    this._cs.newMensaje(this.forma.value)
      .subscribe (data => {
        this.router.navigate(['/exitoso', data.name])
      },
      error => console.error(error));
  }

  ngOnDestroy() {
    this.renderer.setElementClass(document.body, 'paginas-internas', false);
  }

}



// WEBPACK FOOTER //
// /Users/diego/Documents/SirisWebSite/WebSite/src/app/components/contacto/contacto.component.ts